import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
moment().locale("es");

/* APP */
export const isUserAuthorized = (state) => state.authorization;

export const getCurrentRoute = (state) => state.currentRoute;

export const getCurrentRouteTitle = createSelector(
  [getCurrentRoute],
  (route) => route?.title,
);

export const getSideMenuState = (state) => state.app?.isCollapsedSideMenu;

export const getCurrentTheme = (state) => state.currentTheme;

/* PROFILE */
export const getUserProfile = (state) => state.profile;

export const currentUserId = createSelector(
  [getUserProfile],
  (profile) => profile?.id ?? null,
);

export const getCurrentUserRole = createSelector(
  [getUserProfile],
  (profile) =>
    !profile ? null : ROLES_RAW.includes(profile.role) ? profile.role : null,
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = (state) => state.notifications;

/* USERS */
export const getUsers = (state) => state.users;
export const getUsersForm = (state) => state.usersForm;

/* ALERT */
export const getAlerts = (state) => state.alerts;
export const getAlertsForm = (state) => state.alertsForm;

/* CUSTOMERS */
export const getCustomers = (state) => state.customers;
export const getCustomersForm = (state) => state.customersForm;

/* VISITS */
export const getVisits = (state) => state.visits;
export const getVisitsForm = (state) => state.visitsForm;

/* OFFERS */
export const getOffers = (state) => state.Offers;
export const getOffersForm = (state) => state.OffersForm;

/* TEMPLATES */
export const getTemplates = (state) => state.templates;
export const getTemplatesForm = (state) => state.templatesForm;

/* EMAILUSERS */
export const getEmailusers = (state) => state.emailusers;
export const getEmailusersForm = (state) => state.emailusersForm;

/* PRODUCTS */
export const getProducts = (state) => state.products;
export const getProductsForm = (state) => state.productsForm;

/* HISTORICS */
export const getHistorics = (state) => state.historics;
export const getHistoricsForm = (state) => state.historicsForm;

/* NOTES */
export const getNotes = (state) => state.notes;
export const getNotesForm = (state) => state.notesForm;
